import { hasType, schemaMatches } from '@jsonforms/core';
export const isLayoutArray = schemaMatches((schema) => hasType(schema, 'array') && schema.hasOwnProperty('items') && schema.items['type'] == 'object');
